import React, { useEffect, useState } from 'react';
import { Cookie, X } from 'lucide-react';
export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem('skillzhq-cookie-consent');
    if (!consent) {
      // Show banner after a short delay
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('skillzhq-cookie-consent', 'accepted');
    setShowBanner(false);
  };
  const handleDecline = () => {
    localStorage.setItem('skillzhq-cookie-consent', 'declined');
    setShowBanner(false);
  };
  if (!showBanner) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slide-up" data-id="element-219">
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-2xl border-2 border-gray-200 overflow-hidden" data-id="element-220">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 p-6" data-id="element-221">
          {/* Icon */}
          <div className="flex-shrink-0" data-id="element-222">
            <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-green-600 rounded-full flex items-center justify-center" data-id="element-223">
              <Cookie className="w-6 h-6 text-white" data-id="element-224" />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1" data-id="element-225">
            <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-226">
              We Value Your Privacy
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed" data-id="element-227">
              We use cookies to enhance your browsing experience, provide
              personalized content, and analyze our traffic. By clicking "Accept
              All", you consent to our use of cookies. You can manage your
              preferences or learn more in our{' '}
              <a href="/privacy-policy" className="text-blue-600 hover:underline font-medium" data-id="element-228">
                Privacy Policy
              </a>
              .
            </p>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto" data-id="element-229">
            <button onClick={handleDecline} className="px-6 py-2.5 border-2 border-gray-300 text-gray-700 rounded-full hover:bg-gray-50 transition-colors duration-200 font-medium text-sm whitespace-nowrap" data-id="element-230">
              Decline
            </button>
            <button onClick={handleAccept} className="px-6 py-2.5 bg-gradient-to-r from-blue-600 to-green-600 text-white rounded-full hover:shadow-lg transition-all duration-200 font-medium text-sm whitespace-nowrap" data-id="element-231">
              Accept All
            </button>
          </div>
        </div>

        {/* Close button */}
        <button onClick={handleDecline} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close cookie banner" data-id="element-232">
          <X className="w-5 h-5" data-id="element-233" />
        </button>
      </div>
    </div>;
}